import * as React from "react";
import styled from "styled-components";
import defaultTheme from "../defaultTheme";
import getViewportHideStyles from "./helpers/getViewportHideStyles";
import getDisplay from "./helpers/getDisplay";
var StyledHide = styled.span.withConfig({
  displayName: "Hide__StyledHide",
  componentId: "ji2pgq-0"
})(["", ";"], function (_ref) {
  var on = _ref.on;
  return getViewportHideStyles(on, getDisplay);
});
StyledHide.defaultProps = {
  theme: defaultTheme
};

var Hide = function Hide(_ref2) {
  var _ref2$on = _ref2.on,
      on = _ref2$on === void 0 ? [] : _ref2$on,
      block = _ref2.block,
      children = _ref2.children;
  return React.createElement(StyledHide, {
    on: on,
    block: block
  }, children);
};

export default Hide;